export default "__VITE_ASSET__Cv9MYThl__"